// Category color configuration for consistent styling across the app
export const categoryColors = {
  // Admin dashboard - darker, more distinct colors
  admin: {
    produce: 'bg-green-600 text-white',
    'meat-beef': 'bg-red-700 text-white',
    'meat-chicken': 'bg-orange-700 text-white', 
    'meat-pork': 'bg-pink-700 text-white',
    'meat-hotpot': 'bg-rose-700 text-white',
    seafood: 'bg-blue-700 text-white',
    groceries: 'bg-amber-700 text-white'
  },
  // Frontend - 25% more colorful than original but still subtle
  frontend: {
    produce: 'bg-green-200/80 text-green-800 border-green-300',
    'meat-beef': 'bg-red-200/80 text-red-800 border-red-300',
    'meat-chicken': 'bg-orange-200/80 text-orange-800 border-orange-300',
    'meat-pork': 'bg-pink-200/80 text-pink-800 border-pink-300', 
    'meat-hotpot': 'bg-rose-200/80 text-rose-800 border-rose-300',
    seafood: 'bg-blue-200/80 text-blue-800 border-blue-300',
    groceries: 'bg-amber-200/80 text-amber-800 border-amber-300'
  }
};

export function getCategoryColor(category: string, isAdmin: boolean = false): string {
  const colors = isAdmin ? categoryColors.admin : categoryColors.frontend;
  return colors[category as keyof typeof colors] || (isAdmin ? 'bg-gray-600 text-white' : 'bg-gray-200 text-gray-800');
}

export function getCategoryLabel(category: string): string {
  const labels: Record<string, string> = {
    'produce': 'Produce',
    'meat-beef': 'Beef',
    'meat-chicken': 'Chicken', 
    'meat-pork': 'Pork',
    'meat-hotpot': 'Hot Pot',
    'seafood': 'Seafood',
    'groceries': 'Groceries'
  };
  return labels[category] || category;
}